import React, { Component, createRef } from "react";
import {
  GET,
  POST,
  loading,
  alert,
  tokens,
  t,
} from "../components/CustomComponent.js";
import Language from "../components/Language.js";
import Turnstile from "react-turnstile";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      password_view: "password",
      remember: false,
      token: "",
      captchaKey: Date.now(),
      _tokens: tokens
    };
    this.turnstileRef = createRef();
  }

  async componentDidMount() {
    if (tokens) {
      const result = await GET("admin/users/profile", null, false);
      if (result?.status=== true) {
        switch (result.data?.user_type) {
        case "super_user": window.location.href = `/console`; break;
        case "admin-company": window.location.href = `/console`; break;
        case "admin": window.location.href = `/console`; break;
        case "customer": window.location.href = `/console`; break;
        case "warehouse": window.location.href = `/console`; break;
        default: break;
      }
      }else{
        localStorage.clear();
        this.setState({_tokens: null})
      }
    }
    loading(false);
  }

  Login = async () => {
    // window.location.href = `/portal`;
    const { token, email, password } = this.state;
    if(!email){
      alert("", "warning", t("warning"), t("verify_email"));
    }
    if(!password){
      alert("", "warning", t("warning"), t("verify_password"));
    }

    loading(true);
    let result = await POST("auth/login", {
      email: email,
      password: btoa(password),
      token: token,
    });

    if (result?.status === true) {
      // console.log("result.data:",result.data)
      localStorage.setItem("cm-acc-tk", btoa("Bearer " + result.data.token));
      localStorage.setItem("cm-profile", JSON.stringify({...result.data}));
      switch (result.data.user_type) {
        case "super_user": window.location.href = `/console`; break;
        case "admin-company": window.location.href = `/console`; break;
        case "supervisor": window.location.href = `/console`; break;
        case "admin": window.location.href = `/console`; break;
        case "customer": window.location.href = `/console`; break;
        case "technician": window.location.href = `/console`; break;
        case "warehouse": window.location.href = `/console`; break;
        default: break;
      }
      // window.location.href = `/portal`;
    } else {
      this.setState({ token: "", captchaKey: Date.now() });
      alert("", "warning", t("warning"), result?.message || "An error occurred.");
    }
    loading(false);
  };

  render() {
    const { captchaKey, email, password, password_view, _tokens } = this.state;

    return !_tokens ? (
      <div
        className="w-100 min-vh-100 bg-light d-flex align-items-center justify-content-center p-0"
        style={{ backgroundColor: "#f4f7f9" }}
      >
        <div className="row w-100 m-0 min-vh-100">
          {/* LEFT SIDE */}
          <div
            className="col-lg-6 d-none d-lg-flex flex-column justify-content-between p-5 text-white"
            style={{
              background: "linear-gradient(135deg, #1e70cd 0%, #3a91f4 100%)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div className="z-1">
              <div className="d-flex align-items-center mb-5">
                <img src={LOGO} alt="CMMS Logo" style={{ height: "40px" }} />
                <div className="ms-2">
                  <h4 className="mb-0 fw-bold">CMMS</h4>
                  <small>{t("admin_portal")}</small>
                </div>
              </div>

              <div className="mt-5 pt-5">
                <h1 className="display-5 fw-bold mb-3">
                  {t("welcome_to")}
                  <br />
                  {t("admin_portal")}
                </h1>

                <p className="lead mb-5">{t("admin_portal_desc")}</p>

                <ul className="list-unstyled">
                  <li className="mb-3 d-flex align-items-center">
                    <span className="wpx-30 hpx-30 rounded-3 text-primary bg-white d-flex align-items-center justify-content-center me-3">
                      <span className="icon">{"\uf15c"}</span>
                    </span>
                    {t("manage_work_orders")}
                  </li>

                  <li className="mb-3 d-flex align-items-center">
                    <span className="wpx-30 hpx-30 rounded-3 text-primary bg-white d-flex align-items-center justify-content-center me-3">
                      <span className="icon">{"\uf133"}</span>
                    </span>
                    {t("schedule_assign_work")}
                  </li>

                  <li className="mb-3 d-flex align-items-center">
                    <span className="wpx-30 hpx-30 rounded-3 text-primary bg-white d-flex align-items-center justify-content-center me-3">
                      <span className="icon">{"\uf080"}</span>
                    </span>
                    {t("reports_analytics")}
                  </li>
                </ul>
              </div>
            </div>

            <div className="z-1 mt-auto">
              <small className="text-light">{t("footer_text")}</small>
            </div>

            <div
              className="position-absolute border border-white rounded-circle"
              style={{
                width: "400px",
                height: "400px",
                bottom: "-100px",
                right: "-50px",
              }}
            ></div>

            <div
              className="position-absolute border border-white rounded-circle"
              style={{
                width: "200px",
                height: "200px",
                top: "100px",
                right: "10%",
              }}
            ></div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-12 col-lg-6 d-flex flex-column align-items-center justify-content-center bg-light position-relative">
            {/* Language Switcher */}
            <div className="position-absolute top-0 end-0 p-4">
              <Language />
            </div>

            <div
              className="card shadow-lg border-0 rounded-4 p-4 p-md-5"
              style={{ maxWidth: "480px", width: "90%" }}
            >
              <div className="text-center mb-4">
                <div className="bg-primary text-white rounded-3 d-inline-flex p-3 mb-3 shadow">
                  <span className="icon">{"\uf505"}</span>
                </div>
                <h3 className="fw-bold">{t("sign_in")}</h3>
                <p className="text-muted">{t("sign_in_desc")}</p>
              </div>

              {/* Email */}
              <div className="mb-3">
                <label className="form-label small fw-bold">
                  {t("email_or_username")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("placeholder_email")}
                  value={email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                />
              </div>

              {/* Password */}
              <div className="mb-3">
                <label className="form-label small fw-bold">
                  {t("password")}
                </label>
                <input
                  type={password_view}
                  className="form-control"
                  placeholder={t("placeholder_password")}
                  value={password}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  onKeyUp={(e) => e.key === "Enter" && this.Login()}
                />
              </div>

              {/* Remember + Forgot */}
              {/* <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="remember"
                    onChange={(e) =>
                      this.setState({ remember: e.target.checked })
                    }
                  />
                  <label className="form-check-label small" htmlFor="remember">
                    {t("remember_me")}
                  </label>
                </div>

                <a href="#" className="small text-decoration-none">
                  {t("forgot_password")}
                </a>
              </div> */}

              {/* CAPTCHA */}
              <div className="mb-3">
                {/* <Turnstile
                  key={captchaKey}
                  size="flexible"
                  sitekey={process.env.REACT_APP_CLOUDFLARE_SITE_KEY}
                  onVerify={(token) => this.setState({ token })}
                /> */}
              </div>

              {/* Login Button */}
              <button
                className="btn btn-primary w-100 py-2 fw-bold mb-4 shadow-sm"
                onClick={this.Login}
              >
                <span className="icon me-2">{"\uf2f6"}</span> {t("sign_in")}
              </button>

              {/* version */}
              <div className="text-center">
                <small className="text-secondary">CMMS Version {global.version}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}
